import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "name"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, {
    gutter: 24,
    class: "user-bar"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 9
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        placement: "bottom",
        width: "auto",
        trigger: "hover",
        content: $setup.subDepName
      }, {
        reference: _withCtx(() => [$setup.userInfo ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString($setup.userInfo.userName), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["content"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: "logout-btn",
        onClick: _cache[0] || (_cache[0] = (...args) => $setup.logout && $setup.logout(...args))
      }, [_createElementVNode("img", {
        src: require('@/assets/icons/UserBar/logout.png'),
        class: "logout"
      }, null, 8, _hoisted_2), _cache[1] || (_cache[1] = _createTextVNode(" 退出 ", -1))])]),
      _: 1
    })]),
    _: 1
  });
}